import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

export default function Nav() {
  const { t } = useLang();
  const links = [
    { label: t("nav.about"), href: "#about" },
    { label: t("nav.writing"), href: "#writing" },
    { label: t("nav.services"), href: "#services" },
    { label: t("nav.record"), href: "#experience" },
    { label: t("nav.credentials"), href: "#credentials" },
    { label: t("nav.contact"), href: "#contact" },
  ];
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 bg-white/85 backdrop-blur-xl border-b border-black"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-6 h-[72px] flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center">
          <img src="/logo-light.png" alt="ZTrust Africa" className="h-9 w-auto" />
        </a>
        <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-mono text-xs tracking-[0.2em] uppercase text-foreground/70 hover:text-foreground transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="nav-book-call-btn"
            className="hidden sm:inline-flex items-center gap-2 bg-primary text-background font-bold text-sm px-5 py-2.5 hover:bg-accent transition-colors duration-300"
          >
            {t("nav.book")}
          </a>
        </div>
      </div>
    </motion.header>
  );
}
